import React from "react";
import { render } from "react-dom";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import moment from "moment";
import spaceint2 from "../../utils/spaceint2";

const makeOptions = data => {
  const options = {
    tooltip: {
      formatter: function () {
        const date = moment(this.key).format("HH:mm");
        return `<b>${date}</b> | <b>${spaceint2(this.y)}</b>`;
      }
    },

    chart: {
      type: "column",
      margin: [0, 0, 10, 0],
      backgroundColor: "#F8F8F8",
      height: 68,
      width: 250
    },
    title: false,
    subtitle: false,
    exporting: {
      enabled: false
    },
    labels: {
      enabled: false
    },
    xAxis: {
      visible: false,
      gridLineWidth: 0,
      labels: {
        enabled: false
      }
    },
    yAxis: {
      visible: false,
      gridLineWidth: 0,
      labels: {
        enabled: false
      },
      minPointLength: 2,
      borderWidth: 0,
      min: 0,
      title: false
    },
    plotOptions: {
      series: {
        minPointLength: 3,
        pointWidth: 5,
        color: "#A7E36F",
        borderWidth: 0
      }
    },
    series: [
      {
        name: "Показы",
        showInLegend: false,
        data: data.map(d => {
          const item = {
            name: d.date,
            y: d.shows
          };

          if (!item.y) {
            item.color = "#ADB3BA";
          }

          return item;
        })
      }
    ]
  };

  return options;
};

const Chart = ({ data }) => {
  return (
    <div className="teaser__chart">
      <div className="teaser__chart-text">Показы за последние 6 часов</div>
      <HighchartsReact highcharts={Highcharts} options={makeOptions(data)} />
    </div>
  );
};

export default React.memo(Chart);
